/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {IEdisonGameData, IEdisonInitData} from "./data/IEdisonServerData";
import {EdisonIBetWayWinData} from "./data/EdisonParsedGameData";

export class EdisonServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }

    public parseBetWayWins(rawData:IEdisonGameData):EdisonIBetWayWinData[] | undefined{
        return rawData.betWayWins;
    }

    public parseStackedWildModeTriggeredThisSpin(rawData:IEdisonGameData):boolean {
        return rawData.stackedWildModeTriggeredThisSpin;
    }


    public parseRandomWildModeTriggeredThisSpin(rawData:IEdisonGameData):boolean {
        return rawData.randomWildModeTriggeredThisSpin;
    }

    public parseRandomM1WildModeTriggeredThisSpin(rawData:IEdisonGameData):boolean {
        return rawData.randomM1WildModeTriggeredThisSpin;
    }

    public parseRandomM2WildModeTriggeredThisSpin(rawData:IEdisonGameData):boolean {
        return rawData.randomM2WildModeTriggeredThisSpin;
    }

    public parseEvaluatedArea(rawData:IEdisonGameData):string[][] {
        return rawData.evaluatedArea;
    }

    public parseSymbolsCollectedBefore(rawData:IEdisonGameData):number[] {
        return rawData.symbolsCollectedBefore;
    }

    public parseSymbolsCollectedAfter(rawData:IEdisonGameData):number[] {
        return rawData.symbolsCollectedAfter;
    }

    public parseSymbolsCollected(rawData:IEdisonInitData):number[] {
        return rawData.symbolsCollected;
    }

    public parseMeterFSReset(rawData:IEdisonGameData):boolean[] {
        return rawData.meterFSReset;
    }

    public parseStackedModeOverlay(rawData:IEdisonGameData | IEdisonInitData):boolean[] {
        return rawData.stackedModeOverlay;
    }

    public parseStackedNearWinReels(rawData:IEdisonGameData):boolean[] {
        return rawData.stackedNearWinReels;
    }

    public parseFreespinsLeftBefore(rawData:IEdisonGameData):number {
        return rawData.freespinsLeftBefore;
    }

    public parseFsMeterMaxAfterReelIndex(rawData:IEdisonGameData):number[] {
        return rawData.fsMeterMaxAfterReelIndex;
    }

    public parseFsMeterAfterEachReel(rawData:IEdisonGameData):number[][] {
        return rawData.fsMeterAfterEachReel;
    }
}
